import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, logout as apiLogout, me } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, obj = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await me();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = async (email, password) => {
    const u = await apiLogin(email, password);
    setUser(u);
    return u;
  };

  const signOut = async () => {
    try { await apiLogout(); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
